import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=bcc81f8a&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=bcc81f8a&prod&lang=css"
import style1 from "./Home.vue?vue&type=style&index=1&id=bcc81f8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc81f8a",
  null
  
)

export default component.exports